<template lang="pug">
div(id="app")
  div.page-stripe
  div.page-body.container
    div.row
      div.col-xs-12.col-sm-8.col-sm-offset-2.col-lg-6.col-lg-offset-3.page-main
        router-view
    div.text-center.footer
      a(href="https://airform.app" target="_blank") Powered by AirForm
</template>

<script>
export default {
  name: "app"
};
</script>
<style lang="scss">
@import "@/styles/variables.scss";

body {
  background-color: lighten($primary, 30%);
}

.page-stripe {
  background-color: $primary;
  opacity: 1;
  color: #eee;
  width: 100%;
  height: 20vh;
}
.page-main {
  background-color: #f5f5f5;
  margin-top: -10vh;
  min-height: 80vh;
}
.page-body {
  width: 96vw;
  margin-left: 2vw;
}
.footer,
.footer > a,
.footer > a:hover {
  margin: 2vh 0vh 2vh 0vh;
  text-decoration: none;
  color: #333;
  opacity: 0.75;
  font-size: 1.15em;
}
</style>
